import { DeleteOutlined } from '@ant-design/icons';
import { Button, Form } from 'antd';
import classNames from 'classnames';
import { useContext } from 'react';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { RangePicker } from 'app/components/fields/dayjsPickers';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import { dayjs, startOfDay } from 'app/utils/dayjs';

const RULES = [{ required: true, message: 'Set a valid closing period' }];

export const ClosingPeriod = () => {
  const { isViewMode, isEditMode } = useContext(ViewEditModeContext);

  return (
    <FormLineLayout label="Closing period" labelOnTop>
      <Form.List name="closingPeriods">
        {(fields, { add, remove }) => (
          <div className="closingPeriods-container">
            <div className="title_button">
              <Button
                className="add-range"
                onClick={() => add()}
                disabled={isViewMode}
              >
                Add period
              </Button>
            </div>
            <div
              className={classNames([
                'list_closing_periods',
                'closing-periods-list',
              ])}
            >
              {fields.map((subField, idx) => (
                <div className="range-row" key={idx.toString()}>
                  <Form.Item
                    {...subField}
                    label=" "
                    rules={RULES}
                    noStyle
                    getValueFromEvent={(dates) =>
                      dates
                        ? {
                            start: dates[0].format('YYYY-MM-DD'),
                            end: dates[1].format('YYYY-MM-DD'),
                          }
                        : undefined
                    }
                    getValueProps={(value) => ({
                      value: value
                        ? [dayjs(value.start), dayjs(value.end)]
                        : undefined,
                    })}
                  >
                    <RangePicker
                      disabled={isViewMode}
                      bordered={isEditMode}
                      order={false}
                      format="YYYY-MM-DD"
                      disabledDate={(current) =>
                        current &&
                        current.valueOf() < startOfDay(Date.now()).valueOf()
                      }
                    />
                  </Form.Item>
                  {isEditMode && (
                    <div className="delete-range" onClick={() => remove(idx)}>
                      <DeleteOutlined />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </Form.List>
    </FormLineLayout>
  );
};
